import { render, staticRenderFns } from "./tab-misc.vue?vue&type=template&id=2143b658&scoped=true&"
import script from "./tab-misc.vue?vue&type=script&lang=js&"
export * from "./tab-misc.vue?vue&type=script&lang=js&"
import style0 from "./tab-misc.vue?vue&type=style&index=0&id=2143b658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143b658",
  null
  
)

export default component.exports